import DiagnosticsModule from '@modules/DiagnosticsModule';
import { TechnicianTableRow } from './types';

export interface TechnicianCache {
  timestamp: number;
  expiresAt: number;
  tenantIds: string[];
  data: TechnicianTableRow[];
}

export const CACHE_TTL_HOURS: number = 8;
export const CACHE_TTL_MS = CACHE_TTL_HOURS * 60 * 60 * 1000;

function getCacheKey(userId: string): string {
  return `ccp_technicians_${userId}`;
}

export function readTechnicianCache(userId: string): TechnicianCache | null {
  try {
    const raw = localStorage.getItem(getCacheKey(userId));
    if (!raw) return null;
    return JSON.parse(raw) as TechnicianCache;
  } catch {
    return null;
  }
}

export function writeTechnicianCache(
  userId: string,
  data: TechnicianTableRow[],
  tenantIds: string[],
): void {
  try {
    const now = Date.now();
    const cache: TechnicianCache = {
      timestamp: now,
      expiresAt: now + CACHE_TTL_MS,
      tenantIds: [...tenantIds].sort((a, b) => a.localeCompare(b)),
      data,
    };
    localStorage.setItem(getCacheKey(userId), JSON.stringify(cache));
  } catch (e) {
    DiagnosticsModule.reportBackgroundError(
      e,
      'Failed to write technician cache',
    );
  }
}
